export default __webpack_public_path__ + "app/images/cbf109d0741808094f8820ca40883245.png";